import ApisService from './index'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

// báo cáo công nợ
export function getListReportDeptList(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/baocao-tonghop-congnoncc', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// báo cáo công nợ chi tiết
export function getListReportDeptDetail(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/baocao-chitiet-congnoncc', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

